import { render, staticRenderFns } from "./MessageForm.vue?vue&type=template&id=2347f4f5"
import script from "./MessageForm.vue?vue&type=script&lang=js"
export * from "./MessageForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports